import { SmartObjectConditionalSpace as SmartObjectConditionalSpaceBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import SmartObjectConditionalSpaceNodeView from '@/components/editor/SmartObjectConditionalSpaceNodeView'

export const SmartObjectConditionalSpace = SmartObjectConditionalSpaceBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(SmartObjectConditionalSpaceNodeView)
    },
})
